import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { AutenticacaoService } from '../services/autenticacao.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { UsuarioLogado } from '../models/usuario-logado';
import { Login, ResetarSenha } from '../models/login';
import { FuncionarioService } from '../services/funcionario.service';
import swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { Configuracao } from '../models/configuracao';
import { GlobalService } from '../services/global.service';
import { PlatformLocation } from '@angular/common';
import { globals } from '../globals';
import { AppConfigService } from '../services/app-config.service';
import { MatDialog } from '@angular/material';
import { IdentidadeVisualService } from '../services/identidade-visual.service';

declare let $: any;

@Component({
  selector: 'app-resetar-senha',
  templateUrl: './resetar-senha.component.html',
  styleUrls: ['./resetar-senha.component.scss']
})
export class ResetarSenhaComponent implements OnInit, OnDestroy {
  hide1 = true;
  hide2 = true;
  idVisual: any;
  token = '';
  idUsuario = '';

  urls = [];
  urlSelecionada = globals.apiUrl;

  dados: ResetarSenha = new ResetarSenha();

  carregando = false;

  private configuracaoSubscription$: Subscription;
  configuracao: Configuracao;

  private nativeElement: Node;

  senhaInvalida = false;

  constructor(
    private element: ElementRef,
    private autenticacaoService: AutenticacaoService,
    private router: Router,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private funcionarioService: FuncionarioService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private globalService: GlobalService,
    private appConfigService: AppConfigService,
    private identidadeVisualService: IdentidadeVisualService,
  ) {
    this.nativeElement = element.nativeElement;
  }

  ngOnInit() {
    this.buscarIdentidadeVisual();

    this.dialog.closeAll();
    this.urls = this.appConfigService.getServerUrls();

    if (!this.urls.some(p => p === this.urlSelecionada)) {
      this.urlSelecionada = undefined;
    }

    if (this.urls.length === 1) {
      this.urlSelecionada = this.urls[0];
    }

    // inscreve no evento de troca de configuração
    this.configuracaoSubscription$ = this.globalService.alterouConfiguracao.subscribe(conf => {
      this.configuracao = conf;
    });

    this.autenticacaoService.logoutLocal();

    // se for edição, busca o instalador do id passado
    if (this.route.snapshot.paramMap.get('token') && this.route.snapshot.paramMap.get('idusuario')) {
      this.token = this.route.snapshot.paramMap.get('token');
      this.idUsuario = this.route.snapshot.paramMap.get('idusuario');
    } else {
      this.router.navigate(['/']);
    }

    const body = document.getElementsByTagName('body')[0];
    body.classList.add('login-page');
    body.classList.add('off-canvas-sidebar');
    const card = document.getElementsByClassName('card')[0];
    setTimeout(function () {
      // after 1000 ms we add the class animated to the login/register card
      card.classList.remove('card-hidden');
    }, 700);
  }

  buscarIdentidadeVisual() {
    this.carregandoService.mostra('buscarIdentidadeVisual');

    this.identidadeVisualService.consultarIdentidadeVisual().subscribe(idVisual => {
      this.idVisual = idVisual;

      localStorage.setItem('idVisual', JSON.stringify(idVisual));

      this.carregandoService.esconde('buscarIdentidadeVisual');
    }, (erro) => {
      this.carregandoService.esconde('buscarIdentidadeVisual');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-page');
    body.classList.remove('off-canvas-sidebar');

    this.configuracaoSubscription$.unsubscribe();
  }

  public onSubmit() {
    this.resetarSenha();
  }

  validaSenha() {
    if (this.dados.novaSenha !== this.dados.confirmaSenha) {
      this.senhaInvalida = true;
    }
    else {
      this.senhaInvalida = false;
    }
  }

  private resetarSenha() {

    this.carregando = true;

    this.carregandoService.mostra('resetandoSenha');
    globals.apiUrl = this.urlSelecionada;
    localStorage.setItem('urlApi', this.urlSelecionada);


    this.autenticacaoService.resetarSenha(Number(this.idUsuario), this.dados.novaSenha, this.token).subscribe(resp => {

      //this.notificacaoService.sucesso('Senha cadastrada com sucesso!!!');

      this.carregandoService.esconde('resetandoSenha');

      swal(
        {
          title: 'Sucesso!',
          text: 'Senha Cadastrada com Sucesso!',
          type: 'success',
          confirmButtonClass: 'btn btn-info',
          buttonsStyling: false
        }
      ).then(() => {
        this.carregandoService.mostra('resetandoSenha');

        this.router.navigate(['/login']).then(() => {
          this.carregandoService.esconde('resetandoSenha');
          this.carregando = false;
        });
      });

    }, (erro) => {

      this.carregandoService.esconde('resetandoSenha');
      if (erro && erro.statusText && erro.statusText === 'OK') {
        swal(
          {
            title: 'Sucesso!',
            text: 'Senha Cadastrada com Sucesso!',
            type: 'success',
            confirmButtonClass: 'btn btn-info',
            buttonsStyling: false
          }
        ).then(() => {
          this.carregandoService.mostra('resetandoSenha');
          this.router.navigate(['/']).then(() => {
            this.carregandoService.esconde('resetandoSenha');
            this.carregando = false;
          });
        });
      } else {
        this.notificacaoService.erro(erro);
        this.carregando = false;
      }
    });

    // // busca ip
    // this.ipService.getIPAddress().subscribe((respIp: any) => {
    //   // busca localizacao
    //   if (navigator) {
    //     navigator.geolocation.getCurrentPosition(pos => {

    //       this.funcionarioService.confirmarSenha(this.idUsuario, this.dados.novaSenha, respIp.ip,
    //         +pos.coords.latitude + ',' + pos.coords.longitude, this.token).subscribe(resp => {

    //           //this.notificacaoService.sucesso('Senha cadastrada com sucesso!!!');

    //           this.carregandoService.esconde('resetandoSenha');

    //           swal(
    //             {
    //               title: 'Sucesso!',
    //               text: 'Senha Cadastrada com Sucesso!',
    //               type: 'success',
    //               confirmButtonClass: 'btn btn-info',
    //               buttonsStyling: false
    //             }
    //           ).then(() => {
    //             this.carregandoService.mostra('resetandoSenha');

    //             this.router.navigate(['/']).then(() => {
    //               this.carregandoService.esconde('resetandoSenha');
    //               this.carregando = false;
    //             });
    //           });

    //         }, (erro) => {

    //           this.carregandoService.esconde('resetandoSenha');
    //           if (erro && erro.statusText && erro.statusText === 'OK') {
    //             swal(
    //               {
    //                 title: 'Sucesso!',
    //                 text: 'Senha Cadastrada com Sucesso!',
    //                 type: 'success',
    //                 confirmButtonClass: 'btn btn-info',
    //                 buttonsStyling: false
    //               }
    //             ).then(() => {
    //               this.carregandoService.mostra('resetandoSenha');
    //               this.router.navigate(['/']).then(() => {
    //                 this.carregandoService.esconde('resetandoSenha');
    //                 this.carregando = false;
    //               });
    //             });
    //           } else {
    //             this.notificacaoService.erro(erro);
    //           }
    //         });

    //     }, (erro) => {
    //       this.carregandoService.esconde('resetandoSenha');
    //       this.notificacaoService.erro(erro);
    //     });
    //   }
    // }, (erro) => {
    //   this.carregandoService.esconde('resetandoSenha');
    //   this.notificacaoService.erro(erro);
    // });



  }
}
